import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import Axios from "axios";

import AddCircleIcon from "@material-ui/icons/AddCircle";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";

import { useStyles } from "./AddFeeGroup.css";
import { url } from "../../../../../Config/Config";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";
import FormLoader from "../../../../../Components/FormLoader/FormLoader";

class AddFeeGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        studentClass: "",
        faculty: "",
        group: "",
      },
      classList: [],
      feeTypeList: [],
      classError: "",
      facultyError: "",
      groupError: "",
      loading: false,
    };
  }

  componentDidMount() {
    this.getData();
    if (this.props.editStatus) {
      this.setData(this.props.data);
    }
  }

  setData = (data) => {
    this.setState({
      data: {
        studentClass: data.studentClass,
        faculty: data.faculty ? data.faculty : "",
        group: data.group ? data.group : "",
      },
    });
  };

  getData = async () => {
    try {
      const classResponse = await Axios.get(`${url}/api/schoolclass`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (classResponse.data.classes.length !== 0) {
        this.setState({
          classList: classResponse.data.classes,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getData();
      }
    }
  };

  handleChange = (e) => {
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
    });
  };

  handleClassChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        studentClass: e.target.value,
        faculty: "",
        group: "",
      },
    });
  };

  filterFaculty = (classData) => {
    let className = classData ? classData : this.state.data.studentClass;
    const facultyFilter = this.state.classList
      .filter((filter) => filter.className === className)
      .map((filter) => filter.faculty);
    let status = facultyFilter.map((filter) => {
      return filter === null || filter === undefined ? false : true;
    });
    if (status.includes(false)) {
      return false;
    } else {
      return true;
    }
  };

  checkError = (studentClass) => {
    let classError = studentClass ? studentClass : "";
    let facultyError = "";
    let groupError = "";
    let status = this.filterFaculty();

    if (this.state.data.studentClass === "") {
      classError = "Please Select Class";
    }

    if (status) {
      if (!this.state.data.faculty) {
        facultyError = "Please Enter Faculty";
      }
    }

    if (this.state.data.faculty) {
      if (!this.state.data.group) {
        groupError = "Please select group ";
      }
    }

    if (classError || facultyError || groupError) {
      this.setState({
        classError,
        facultyError,
        groupError,
      });
      return true;
    } else {
      this.setState({
        classError: "",
        facultyError: "",
        groupError: "",
      });
      return false;
    }
  };

  filterData = (data) => {
    let changedData = data;
    if (!changedData.faculty) {
      delete changedData.faculty;
    }
    if (!changedData.group) {
      delete changedData.group;
    }
    return changedData;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      try {
        this.setState({ loading: true });
        let data = this.filterData(this.state.data);
        console.log(data);
        if (this.props.editStatus) {
          const response = await Axios.put(
            `${url}/api/fee-groups/${this.props.data._id}`,
            data,
            {
              headers: {
                Authorization: `Bearer ${this.props.adminToken}`,
              },
            }
          );
          if (response.data.message === "Fees group edited successfully") {
            this.props.getFeeGroup();
            this.props.handleCancelEdit();
          }
        } else {
          const response = await Axios.post(`${url}/api/fee-groups`, data, {
            headers: {
              Authorization: `Bearer ${this.props.adminToken}`,
            },
          });
          if (response.data.groupId) {
            this.setState({
              data: {
                studentClass: "",
                faculty: "",
                group: "",
              },
              loading: false,
            });
            this.props.getFeeGroup();
          }
        }
      } catch (error) {
        this.setState({ loading: false });
        if (
          error.response.data.message ===
          "Fee group with given data already saved"
        ) {
          console.clear();
          this.checkError(error.response.data.message);
        }
        if (
          error.response.data === "jwt expired" &&
          error.response.status === 401
        ) {
          console.clear();
          let refreshToken = { refreshToken: this.props.refreshToken };
          this.props.getAdminRefreshToken(refreshToken, this.props.role);
          this.handleSubmit(e);
        }
      }
    }
  };

  render() {
    const { classes } = this.props;
    const { data } = this.state;
    const classFilter = this.state.classList.map((filter) => filter.className);
    const facultyFilter = this.state.classList
      .filter((filter) => filter.className === data.studentClass)
      .map((filter) => filter.faculty);
    const groupFilter = this.state.classList
      .filter((filter) => filter.faculty === data.faculty)
      .map((filter) => filter.group);
    return (
      <TableRow>
        <TableCell />
        <TableCell
          align="center"
          style={{ paddingTop: this.state.classError === "" && 0 }}
        >
          <TextField
            name="studentClass"
            select
            required
            fullWidth
            variant="outlined"
            margin="normal"
            SelectProps={{ native: true }}
            error={this.state.classError ? true : false}
            helperText={this.state.classError}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.studentClass}
            onChange={this.handleClassChange}
          >
            <option value="">Select Any One</option>
            {classFilter
              .filter((value, index) => classFilter.indexOf(value) === index)
              .map((classData, index) => (
                <option key={index} value={classData}>
                  {classData}
                </option>
              ))}
          </TextField>
        </TableCell>
        <TableCell
          align="center"
          style={{ paddingTop: this.state.data.faculty && 0 }}
        >
          <TextField
            name="faculty"
            select
            fullWidth
            variant="outlined"
            margin="normal"
            error={this.state.facultyError ? true : false}
            helperText={
              this.state.facultyError
                ? this.state.facultyError
                : data.faculty
                ? null
                : facultyFilter.length === 0
                ? "Please Select Class to get faculties"
                : "No any faculty for this class"
            }
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.faculty}
            onChange={this.handleChange}
          >
            <option value="">Select Any One</option>
            {facultyFilter
              .filter((value, index) => facultyFilter.indexOf(value) === index)
              .map((classData, index) => (
                <option key={index} value={classData}>
                  {classData}
                </option>
              ))}
          </TextField>
        </TableCell>
        <TableCell
          align="center"
          style={{ paddingTop: this.state.data.group && 0 }}
        >
          <TextField
            name="group"
            select
            fullWidth
            variant="outlined"
            margin="normal"
            style={{ marginRight: 20 }}
            error={this.state.groupError ? true : false}
            helperText={
              this.state.groupError
                ? this.state.groupError
                : data.group
                ? null
                : groupFilter.length === 0
                ? "Please Select Faculty to get groups"
                : "No any group for this group"
            }
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.group}
            onChange={this.handleChange}
          >
            <option value="">Select Any One</option>
            {groupFilter
              .filter((value, index) => groupFilter.indexOf(value) === index)
              .map((group, index) => (
                <option key={index} value={group}>
                  {group}
                </option>
              ))}
          </TextField>
        </TableCell>
        <TableCell />
        <TableCell align="center">
          {this.props.editStatus ? (
            <>
              <Tooltip
                arrow
                title="Update"
                className={classes.tooltip}
                onClick={this.handleSubmit}
              >
                <CheckCircleIcon />
              </Tooltip>
              <Tooltip
                arrow
                title="Delete"
                className={classes.tooltip}
                onClick={() => this.props.handleCancelEdit()}
              >
                <CancelIcon />
              </Tooltip>
            </>
          ) : (
            <Tooltip
              arrow
              title="Add"
              className={classes.tooltip}
              onClick={this.handleSubmit}
            >
              <AddCircleIcon />
            </Tooltip>
          )}
          <br />
          {this.state.loading && <FormLoader />}
        </TableCell>
      </TableRow>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    isAdmin: state.AdminReducer.isAdmin,
    role: state.AdminReducer.role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(AddFeeGroup)));
